module.exports = __webpack_public_path__ + "assets/stickeryo_logo@2x-5b7d5d95377f2c868ff502890216e8e1.png";